import {
  SET_RECOVERY_MASKED_DATA,
  SET_RECOVERY_STEP,
  SET_RECOVERY_REQUESTID,
} from './actions/types'

const INITIAL_STATE = {
  recoveryStep: 0,
  recoveryRequestId: null,
  recoveryMaskedData: null,
}

function setRecoveryMaskedData(state, action) {
  return {
    ...state,
    recoveryMaskedData: action.payload.recoveryMaskedData,
  }
}

function setRecoveryStep(state, action) {
  return {
    ...state,
    recoveryStep: action.payload.recoveryStep,
  }
}

function setRecoveryRequestId(state, action) {
  return {
    ...state,
    recoveryRequestId: action.payload.recoveryRequestId,
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_RECOVERY_MASKED_DATA:
      return setRecoveryMaskedData(state, action)
    case SET_RECOVERY_STEP:
      return setRecoveryStep(state, action)
    case SET_RECOVERY_REQUESTID:
      return setRecoveryRequestId(state, action)
    default:
      break
  }
  return state
}

export default reducer
